import React, { useState, useEffect } from 'react'
import { Navbar, NavbarBrand } from 'reactstrap'
import { useNavigate } from 'react-router-dom'

import logoImg from '../assets/images/KOPI_logo.png'
import { ROUTES } from '@common'

const NavBar = () => {
    const navigate = useNavigate()
    const [isVisible, setIsVisible] = useState(true)
    const hideThreshold = 50

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > hideThreshold) {
                setIsVisible(false)
            } else {
                setIsVisible(true)
            }
        }

        window.addEventListener('scroll', handleScroll)
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    return (
        <Navbar
            light
            expand="md"
            className="px-4 py-2"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                backgroundColor: 'white',
                transition: 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out',
                zIndex: 1000,
                transform: isVisible ? 'translateY(0)' : 'translateY(-100%)',
                opacity: isVisible ? 1 : 0,
            }}
        >
            <NavbarBrand className="fw-bold m-0 justify-content-center" onClick={() => navigate(ROUTES.root)}>
                <img src={logoImg} alt="Kopi+ Logo" style={{ height: '40px' }} />
            </NavbarBrand>
        </Navbar>
    )
}

export default NavBar
